import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from './messages';
import useHasPermission from '../../hooks/useHasPermission';
import { resolveFloorPlanDisplay } from '../../utils/floorPlan';
import type { FloorPlan } from '../../containers/ManageFloorPlans/types';

type Props = {
  floorPlans: ?(FloorPlan[]),
  unitFloorPlanId: ?string,
  preferredFloorPlanId: ?string,
  propertyId: string,
  // Right-aligned slot for a caller-owned control. The design puts it on this row rather than
  // beside it, and the row owns its own <li>, so it cannot be a sibling.
  action?: React$Node,
};

/**
 * The Floor Plan row of a profile Snapshot's DetailList — renders its own <li>
 * so both Snapshot widgets stay one line and share the label, link and empty states.
 */
const FloorPlanDetailRow = ({
  floorPlans,
  unitFloorPlanId,
  preferredFloorPlanId,
  propertyId,
  action,
}: Props) => {
  const canReadFloorPlan = useHasPermission('floor-plan-read');
  const { name, isNoPreference, linkableId } = resolveFloorPlanDisplay({
    floorPlans,
    unitFloorPlanId,
    preferredFloorPlanId,
  });

  const value = name ?? (
    <FormattedMessage
      {...(isNoPreference ? messages.noPreference : messages.unassigned)}
    />
  );

  return (
    <li
      data-testid="floorPlanRow"
      style={
        action
          ? { display: 'flex', alignItems: 'center', gap: '4px' }
          : undefined
      }
    >
      {' '}
      <FormattedMessage {...messages.floorPlan} />{' '}
      {linkableId && canReadFloorPlan ? (
        <Link to={`/property/${propertyId}/floorplan/${linkableId}`}>
          {value}
        </Link>
      ) : (
        value
      )}
      {action ? (
        <Box marginLeft={'auto'} maxWidth={'fit-content'}>
          {action}
        </Box>
      ) : null}
    </li>
  );
};

export default FloorPlanDetailRow;
